import { createStore, CreateStore } from 'redux';
import { persistReducer } from 'redux-persist';
//import storage from 'redux-persist/lib/storage';  // localstorage 사용
import storage from 'redux-persist/lib/storage/session'; // sessionstorage 사용
import qs from 'query-string';
const location = window.location.search;

let query = qs.parse(location);
const lang = query.lang;

var initState = {
  mode: lang ? lang : 'en',
  welcome_content: {
    title: 'WEB',
    desc: 'Hello, Web',
  },
  selected_content: 1,
  contents: [
    { id: 1, title: 'HTML', desc: 'HTML content...' },
    { id: 2, title: 'css', desc: 'css content...' },
    { id: 3, title: 'js', desc: 'js content...' },
  ],
};

const persistConfig = {
  // 새로운 persist config를 선언해준다.
  key: 'root',
  // reducer 객체의 어느 지점에서 부터 데이터를 저장할 것인지 설정해주는것이 key이다.
  // root부터 시작한다고 지정해준다.
  storage: storage,
  // 위에 import 한 성격의 storage를 지정해준다. 이 예제의 경우에는 localstorage
  //whitelist: ["mode", "selected_content", "contents"],
  // 유지 및 보존하고 싶은 데이터를 배열안에 지정해준다.
  // string 형태이고 아래 combineReducers에 지정된 값들을 사용해주면 된다.
};

function reducer(state = initState, action) {
  if (action.type == 'CHANGE_MODE') {
    return { ...state, mode: action.mode };
  }
  return state;
}

export default persistReducer(persistConfig, reducer);

// import { createStore, CreateStore } from 'redux';

// var initState = {
//     mode:'READ',
//     welcome_content:{
//         title:'WEB',
//         desc:'Hello, Web'
//     },
//     selected_content:1,
//     contents:[
//         {id:1, title:'HTML', desc:"HTML content..."},
//         {id:2, title:'css', desc:"css content..."},
//         {id:3, title:'js', desc:"js content..."}
//     ]
// }

// function reducer(state=initState, action){
//     if(action.type=='CHANGE_MODE'){
//         return { ...state, mode:action.mode }
//     }
//     return state;
// }

// export default reducer;
